import React, { useEffect, useState } from 'react';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import ShowStatus from 'views/ContactUs/subcomponents/QueriesAndComplaints/components/TicketTracking/subcomponents/ShowStatus';
import { ContactService } from 'services/contact/contact';
import { finalize } from 'rxjs/operators';
import { Ticket } from 'utils/api/models/troubleTicketing/ticket';
import { resolveTicketStatus } from 'views/ContactUs/helpers/resolveTicketStatus';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';
import style from 'assets/jss/material-dashboard-pro-react/views/listOfComplaints/complaintDetailsDialogStyle';
import { makeStyles } from '@material-ui/core';
import { translate } from 'components/Translation';
import { getLanguage } from 'utils/language/language';
import { setDataLayer } from 'commons/gtm/dataLayerWrapper';
import { upIdSelector } from 'redux/modules/session/selectors';
import { useSelector } from 'react-redux';

// @ts-ignore
const useStyles = makeStyles(style);

interface IComplaintDetailsDialogProps {
	ticketId: string;
	hideDialog: () => void;
}

const ComplaintDetailsDialog = ({ ticketId, hideDialog }: IComplaintDetailsDialogProps) => {
	const [loading, setLoading] = useState<boolean>(false);
	const [ticketData, setTicketData] = useState<Ticket | null>(null);
	const [status, setStatus] = useState<types.troubleTicketing.finalStatus | null>(null);
	const classes = useStyles();
	const accId = useSelector(upIdSelector);

	useEffect(() => {
		setLoading(true);
		ContactService.retrieveOsmInteraction({ interactionId: ticketId })
			.pipe(finalize(() => setLoading(false)))
			.subscribe((interaction) => {
				setTicketData(interaction);
				setStatus(resolveTicketStatus(interaction, 'INTERACTION')?.[2] || null);
				setDataLayer('ticket_detail_view', getLanguage(), null, accId, null, {
					type: 'ticket detail',
					ticket_num: ticketId,
					source: 'History of compaints',
				});
			});
	}, [ticketId]);

	return (
		<CustomDialog
			isOpen={true}
			hideDialog={hideDialog}
			dialogBody={
				<ConditionalRender
					show={loading}
					onTrue={() => (
						<div className={classes.circularProgressWrapper}>
							<CustomCircularProgress text={translate('it.can.take.a.while')} loading transparent />
						</div>
					)}
					onFalse={() => (
						<div className={classes.dialogWrapper}>
							<ShowStatus ticketData={ticketData} ticketId={ticketId} status={status} />
						</div>
					)}
				/>
			}
		/>
	);
};

export default ComplaintDetailsDialog;
